module.exports = __webpack_public_path__ + "img/LeilaAlland.2180001f.png";